import { GridApi } from 'ag-grid-community';
import { useEffect, useState } from 'react';

import { IQuotePart } from 'quotes/types';

import { findNextEditableLine, IsLineEditable } from './nextLine';

interface IProps {
  gridApi: GridApi;
  currentLineId: number;
  isLineEditable?: IsLineEditable;
  enabled: boolean;
}

// The drawer is interactive: the grid behind it can be sorted or filtered while it is open.
export const useNextEditableLine = ({
  gridApi,
  currentLineId,
  isLineEditable,
  enabled,
}: IProps) => {
  const [nextLine, setNextLine] = useState<IQuotePart | null>(null);

  useEffect(() => {
    if (!enabled || !gridApi || !isLineEditable) {
      setNextLine(null);

      return;
    }

    const updateNextLine = () =>
      setNextLine(findNextEditableLine(gridApi, currentLineId, isLineEditable));

    updateNextLine();
    gridApi.addEventListener('modelUpdated', updateNextLine);

    return () => {
      if (!gridApi.isDestroyed()) {
        gridApi.removeEventListener('modelUpdated', updateNextLine);
      }
    };
  }, [currentLineId, enabled, gridApi, isLineEditable]);

  return nextLine;
};
